/* WF 10-24 Halloween gift card, Hip Pack 2.0 (data + chip + CSS: snippets/wf-hw-gift.liquid).
   - On only between data.start and data.end (checked here in the browser, Liquid "now" is cached). ?wf_hw=1 previews before start.
   - Builds the gift card right above the FastBundle Pack'n Carry add-on (#rbr-container-element-addOn); hides that add-on while Merlot is selected.
   - Add to cart: hooks the browser "formdata" event, so the theme's own product-form.js request carries
     items[0] = Hip Pack (chosen qty) + items[1] = chosen Pack'n Carry (qty 1) in ONE /cart/add call; drawer, errors and pubsub stay the theme's.
   - No gift is added if one of the Pack'n Carry variants is already in the cart. Buy it now is hidden while the gift is ticked. */
(function () {
  if (window.__wfHw) return;
  var el = document.querySelector('script[data-wf-hw]');
  if (!el) return;
  var D;
  try { D = JSON.parse(el.textContent); } catch (e) { return; }
  var now = Date.now(), S = D.start * 1000, E = D.end * 1000;
  var preview = /[?&]wf_hw=1(&|$)/.test(location.search);
  if (now > E || (now < S && !preview)) return;
  var G = D.gift, V = G.variants || [];
  if (!V.some(function (v) { return v.a; })) return;
  window.__wfHw = 1;

  var H = document.documentElement;
  var info = document.querySelector('product-info[id^="MainProduct"]') || document;
  var pf = info.querySelector('.product__info-container product-form.product-form') || info.querySelector('product-form.product-form');
  if (!pf) return;
  var form = pf.querySelector('form');
  var submit = pf.querySelector('[type="submit"][name="add"]');
  var ids = V.map(function (v) { return String(v.id); });
  var sel = (V.filter(function (v) { return v.a; })[0] || V[0]).o.slice();
  var inCart = false, injected = false, endTimer;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function find(o) { return V.filter(function (v) { return v.o.join('|') === o.join('|'); })[0]; }
  function okWith(i, val) {
    return V.some(function (v) {
      if (!v.a || v.o[i] !== val) return false;
      for (var k = 0; k < i; k++) if (v.o[k] !== sel[k]) return false;
      return true;
    });
  }
  function chosen() { var v = find(sel); return v && v.a ? v : null; }
  function curId() { var i = form && form.querySelector('input[name="id"]'); return i ? String(i.value) : ''; }
  function isM() { return curId() === String(D.merlot); }

  /* ---------- card ---------- */
  var card = document.createElement('div');
  card.className = 'wfg';
  card.id = 'wf-hw-gift';
  card.setAttribute('role', 'group');
  card.setAttribute('aria-label', 'Halloween gift');
  var optsHtml = (G.opts || []).map(function (name, i) {
    var vals = [];
    V.forEach(function (v) { if (vals.indexOf(v.o[i]) < 0) vals.push(v.o[i]); });
    return '<div class="wfg__opt"><span class="wfg__lab">' + esc(name) + '</span><div class="wfg__btns">' +
      vals.map(function (val) { return '<button type="button" class="wfg__b" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>'; }).join('') +
      '</div></div>';
  }).join('');
  card.innerHTML =
    '<div class="wfg__full">' +
      '<div class="wfg__head"><span class="wfg__eye">&#127875; Halloween gift</span><span class="wfg__t">Pack’n Carry, free with Blackberry Merlot</span></div>' +
      '<div class="wfg__body">' +
        '<div class="wfg__row"><img class="wfg__img" alt="Pack’n Carry waste bag carrier" width="56" height="56" loading="lazy"><div><p class="wfg__vn"></p><p class="wfg__price"><s></s><span class="wfg__free">FREE</span></p></div></div>' +
        optsHtml +
        '<label class="wfg__chk"><input type="checkbox" checked data-wfg-chk> <span>Add my free Pack’n Carry</span></label>' +
        '<p class="wfg__fine">Added at $0 when you check out with this color. Can’t be combined with other offers.</p>' +
        '<p class="wfg__in" hidden>&#10003; A Pack’n Carry is already in your cart. It’s free with this color at checkout.</p>' +
        '<p class="wfg__err" role="alert" hidden></p>' +
      '</div>' +
    '</div>' +
    '<div class="wfg__slim"><span>&#127875; Pick Blackberry Merlot and get a Pack’n Carry free</span><button type="button" class="wfg__pick" data-wfg-pick>Pick Merlot</button></div>';
  var chk = card.querySelector('[data-wfg-chk]');

  function paint() {
    card.querySelectorAll('.wfg__b').forEach(function (b) {
      var i = +b.dataset.i, val = b.dataset.v;
      b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
      b.disabled = !okWith(i, val);
    });
    var v = chosen() || find(sel) || V[0];
    card.querySelector('.wfg__vn').textContent = v.o.join(' · ');
    card.querySelector('.wfg__price s').textContent = v.p;
    var img = card.querySelector('.wfg__img');
    var src = v.img || G.img;
    if (src && img.getAttribute('src') !== src) img.src = src;
  }

  function place() {
    var addon = document.getElementById('rbr-container-element-addOn');
    var anchor = addon && addon.parentElement === pf.parentElement ? addon : pf;
    if (card.nextElementSibling !== anchor) anchor.parentElement.insertBefore(card, anchor);
  }

  function uncheckFastBundle() {
    var fb = document.querySelector('#rbr-container-element-addOn input[type="checkbox"]');
    if (fb && fb.checked) (fb.closest('label') || fb).click();
  }

  function update() {
    if (Date.now() > E) { off(); return; }
    var m = isM();
    H.classList.toggle('wf-hw-merlot', m);
    card.classList.toggle('is-in', inCart);
    card.classList.toggle('is-off', !chk.checked);
    card.querySelector('.wfg__in').hidden = !inCart;
    var gifting = m && chk.checked && !inCart && !!chosen();
    H.classList.toggle('wf-hw-gifting', gifting);
    if (submit) {
      if (gifting && submit.classList.contains('button--secondary')) { submit.classList.replace('button--secondary', 'button--primary'); submit.dataset.wfHwSec = '1'; }
      else if (!gifting && submit.dataset.wfHwSec) { submit.classList.replace('button--primary', 'button--secondary'); delete submit.dataset.wfHwSec; }
    }
    if (m) uncheckFastBundle();
  }

  function off() {
    H.classList.remove('wf-hw-live', 'wf-hw-merlot', 'wf-hw-gifting');
    if (submit && submit.dataset.wfHwSec) { submit.classList.replace('button--primary', 'button--secondary'); delete submit.dataset.wfHwSec; }
    if (card.parentElement) card.remove();
    window.__wfHwOff = 1;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCart = (c.items || []).some(function (it) { return ids.indexOf(String(it.variant_id)) > -1; });
        update();
      }).catch(function () {});
  }

  function refreshStock() {
    return fetch('/products/' + G.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        (p.variants || []).forEach(function (pv) { var v = V.filter(function (x) { return String(x.id) === String(pv.id); })[0]; if (v) v.a = !!pv.available; });
        if (!chosen()) { var f = V.filter(function (v) { return v.a; })[0]; if (f) sel = f.o.slice(); }
        paint(); update();
      }).catch(function () {});
  }

  /* ---------- events ---------- */
  card.addEventListener('click', function (e) {
    var b = e.target.closest('.wfg__b');
    if (b && !b.disabled) {
      var i = +b.dataset.i;
      sel[i] = b.dataset.v;
      for (var k = i + 1; k < sel.length; k++) {
        if (!okWith(k, sel[k])) {
          var alt = V.filter(function (v) { if (!v.a) return false; for (var q = 0; q < k; q++) if (v.o[q] !== sel[q]) return false; return true; })[0];
          if (alt) sel[k] = alt.o[k];
        }
      }
      card.querySelector('.wfg__err').hidden = true;
      paint(); update();
      return;
    }
    if (e.target.closest('[data-wfg-pick]')) {
      var r = document.querySelector('variant-selects input[type="radio"][value="' + String(D.merlotName).replace(/"/g, '\\"') + '"]');
      if (r) { r.click(); }
      else { location.href = location.pathname + '?variant=' + D.merlot + (preview ? '&wf_hw=1' : ''); }
    }
  });
  chk.addEventListener('change', function () { card.querySelector('.wfg__err').hidden = true; update(); });

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-wf-hw-chip]');
    if (!c) return;
    e.preventDefault();
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') setTimeout(update, 0);
  });

  /* Add to cart: rewrite the theme's FormData (one request, theme flow untouched). */
  document.addEventListener('formdata', function (e) {
    injected = false;
    if (window.__wfHwOff || Date.now() > E) return;
    var f = e.target, fd = e.formData;
    if (!f || !fd || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (String(fd.get('product-id')) !== String(D.pid)) return;
    var vid = String(fd.get('id') || '');
    if (vid !== String(D.merlot)) return;
    var g = chosen();
    if (!chk.checked || inCart || !g) return;
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    fd.delete('id');
    fd.delete('quantity');
    fd.append('items[0][id]', vid);
    fd.append('items[0][quantity]', String(qty));
    fd.append('items[1][id]', String(g.id));
    fd.append('items[1][quantity]', '1');
    injected = true;
  }, true);

  function hookPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { injected = false; setTimeout(refreshCart, 60); });
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(update, 0); });
    subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
      if (!injected) return;
      injected = false;
      var err = card.querySelector('.wfg__err');
      err.textContent = 'We couldn’t add the gift with your Hip Pack just now. Pick another style or untick the gift, then tap Add to cart again.';
      err.hidden = false;
      refreshStock();
    });
    return true;
  }

  function start() {
    H.classList.add('wf-hw-live');
    paint();
    place();
    update();
    if (window.MutationObserver) new MutationObserver(place).observe(pf.parentElement, { childList: true });
    if (!hookPubSub()) setTimeout(hookPubSub, 1500);
    refreshCart();
    refreshStock();
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
    var left = E - Date.now();
    if (left < 2147483647) endTimer = setTimeout(off, left + 1000);
    if (preview && now < S && window.console) console.info('[wf-hw] Halloween gift preview (wf_hw=1) before start');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
